/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';
import { IFooterCategoryData } from './footer-category.data';
import { IFooterCategoryConfig, IFooterCategoryProps } from './footer-category.props.autogenerated';
import { Customer } from '@msdyn365-commerce/retail-proxy';
export interface IFooterCategoryViewProps extends IFooterCategoryProps<IFooterCategoryConfig> {
    categories: React.ReactNode[];
    FooterList: IModuleProps;
    FooterListItem: INodeProps;
}

/**
 *
 * FooterCategory component.
 * @extends {React.PureComponent<IFooterCategoryProps<IFooterCategoryData>>}
 */
class FooterCategory extends React.PureComponent<IFooterCategoryProps<IFooterCategoryData>> {
    public async componentDidMount() {
        function fetchCustomerData(customerInformation?: Customer) {
            //Here it is assumed that the corresponding work stream would have context variables with logical name of 'contextKey1', 'contextKey2', 'contextKey3'. If no context variable exists with a matching logical name, items are created assuming Type:string
            return {
                Email: customerInformation?.Email ? customerInformation?.Email : 'testMe@yopmail.com'
            };
        }
        const CustomerData = fetchCustomerData(this.props.data?.customerInformation?.result);
        window.addEventListener('lcw:ready', function handleLivechatReadyEvent() {
            // Handle LiveChat Ready event
            // SDK methods are ready for use now
            // Setting custom context provider to be used with Chat for Dynamics 365
            // The custom context provided by custom context provider can be used for routing the chat to a particular queue
            // @ts-ignore
            Microsoft.Omnichannel.LiveChatWidget.SDK.setContextProvider(CustomerData);
            // Starting a new chat
            // @ts-ignore
            //Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
        });

        window.addEventListener('lcw:error', function handleLivechatErrorEvent(errorEvent) {
            // Handle LiveChat SDK error event
            console.log(errorEvent);
        });
    }

    public render(): JSX.Element | null {
        if (!this.props.slots || !this.props.slots.content || this.props.slots.content.length === 0) {
            this.props.context.telemetry.error('footer slots content is empty, module wont render');
            return null;
        }
        const viewprops = {
            ...this.props,
            categories: this.props.slots.content,
            FooterList: {
                moduleProps: this.props,
                className: classnames('ms-footer__list', this.props.config.className),
                tag: 'ul'
            },
            FooterListItem: {
                className: classnames('ms-footer__list-item', this.props.config.className),
                tag: 'li'
            }
        };

        return this.props.renderView(viewprops) as React.ReactElement;
    }
}

export default FooterCategory;
